import { z } from "zod/v4";

import { VariationDto, VariationDtoSchema } from "../dtos/variations";

import { ShippingRateGroupFeSchema } from "./shipping-rate-groups";

export const VariationFePropsSchema = z.object({
  label: z.string(),
  // backgroundColor: z.string(),
  // width: z.number(),
});
export type VariationFeProps = z.infer<typeof VariationFePropsSchema>;

export const CreateVariationFeSchema = z.object({
  experienceId: z.uuid().optional(),
  shippingRateGroups: z.optional(ShippingRateGroupFeSchema.array().default([])),
});
export const VariationFeSchema = z
  .object({
    ...VariationDtoSchema.shape,
    ...VariationFePropsSchema.shape,
    ...CreateVariationFeSchema.shape,
  })
  .omit({
    onsiteEdits: true,
    onsiteInjections: true,
    redirects: true,
    userInterfaces: true,
  });

export type VariationFe = z.infer<typeof VariationFeSchema>;

export type GenericVariationFe = VariationFe | VariationDto;
